import React,{useEffect,useState} from "react";
import Master from "./Master";
import { Link } from "react-router-dom";

function Home(){

  const [menuOpen, setMenuOpen] = useState(false);
  const [openSubmenu, setOpenSubmenu] = useState(null);
  const [news, setNews] = useState([]);

  useEffect(() => {
    fetch("https://drpatangecitydentalclinic.com/api/latestnews.php")
      .then(res => res.json())
      .then(data => setNews(data));
  }, []);

    return(
        <div>
    
{/* Header Start */}
    <header className="main-header">
        <div className="header-sticky">
            <nav className="navbar navbar-expand-lg">
                <div className="container">
                    {/* Logo Start */}
                    <a className="navbar-brand" href="./">
                        <img src="/images/logo.svg" alt="Logo"/>
                    </a>
                    {/* Logo End */}

                    {/* Main Menu Start */}
                    <div className={`collapse navbar-collapse main-menu ${menuOpen ? "show" : ""}`}>
                        <div className="nav-menu-wrapper">
                            <ul className="navbar-nav mr-auto" id="menu">
                                        <li className="nav-item"><Link className="nav-link" to={`/`} onClick={() => setMenuOpen(false)}>Home</Link></li>
                                
                                <li className="nav-item"><Link className="nav-link" to={`/about`} onClick={() => setMenuOpen(false)}>About Us</Link></li>
                                <li className="nav-item"><Link className="nav-link" to={`/service`} onClick={() => setMenuOpen(false)}>Services</Link></li>
                                <li className={`nav-item submenu ${openSubmenu === "gallery" ? "active" : ""}`}>
                                <Link
                                    className="nav-link"
                                    onClick={() =>
                                        setOpenSubmenu(openSubmenu === "gallery" ? null : "gallery")
                                    }
                                >
                                    Gallery
                                </Link>

                                <ul>
                                    <li className="nav-item">
                                        <Link
                                            className="nav-link"
                                            to="/photo"
                                            onClick={() => {
                                                setMenuOpen(false);
                                                setOpenSubmenu(null);
                                            }}
                                        >
                                            Photo
                                        </Link>
                                    </li>

                                    <li className="nav-item">
                                        <Link
                                            className="nav-link"
                                            to="/video"
                                            onClick={() => {
                                                setMenuOpen(false);
                                                setOpenSubmenu(null);
                                            }}
                                        >
                                            Video
                                        </Link>
                                    </li>
                                </ul>
                            </li>
                                <li className="nav-item"><Link className="nav-link" to={`/news`} onClick={() => setMenuOpen(false)}>News & Events</Link></li>
                                <li className="nav-item"><Link className="nav-link" to={`/contact`} onClick={() => setMenuOpen(false)}>Contact Us</Link></li>
                                <li className="nav-item highlighted-menu"><Link className="nav-link" to={`/appointment`} onClick={() => setMenuOpen(false)}>book appointment</Link></li>                               
                            </ul>
                        </div>
                        {/* Let’s Start Button Start */}
                        <div className="header-btn d-inline-flex">
                            <Link to={`/appointment`} className="btn-default" onClick={() => setMenuOpen(false)}>book appointment</Link>
                        </div>
                        {/* Let’s Start Button End */}
                    </div>
                    {/* Main Menu End */}
                    <div className="navbar-toggle" onClick={() => setMenuOpen(!menuOpen)}>☰</div>
                    </div>
            </nav>
            <div className="responsive-menu"></div>
        </div>
    </header>
    {/* Header End */}     
    {/* Hero Section Start */}
	<div className="hero">
		<div className="container">
            <div className="row align-items-center">
                <div className="col-lg-6">
                    {/* Hero Content Start */}
                    <div className="hero-content">
                        {/* Section Title Start */}
                        <div className="section-title">
                            <h1 className="text-anime-style-2" data-cursor="-opaque">Experience <span>Dental Excellence</span> with Best Dental Clinic in Palus</h1>
                            <p className="wow fadeInUp" data-wow-delay="0.25s">City Dental Clinic is a modern dental care center offering advanced treatments with a focus on comfort, precision, and patient satisfaction.</p>
                        </div>
                        {/* Section Title End */}

                        {/* Hero Content Body Start */}
                        <div className="hero-content-body wow fadeInUp" data-wow-delay="0.5s">
                            <Link className="btn-default" to={"/appointment"}>make an appointment</Link>
                        </div>
                        {/* Hero Content Body End */}
                    </div>
                    {/* Hero Content End */}
                </div>

                <div className="col-lg-6">
                    {/* Hero Image Start */}
                    <div className="hero-image">
                        {/* Hero Img Start */}
                        <div className="hero-img">
                            <figure>
                                <img src="images/Mainphoto.png" alt="" />
                            </figure>
                        </div>
                        {/* Hero Img End */}

                        {/* Hero Image Tag Start */}
                        <div className="export-dantist-box">
                            <div className="icon-box">
                                <figure className="image-anime">
                                    <img src="images/Mainphoto.png" alt="" />
                                </figure>
                            </div>
                            <div className="export-dantist-content">
                                <h3>dr. Vishal Patange</h3>
                                <p>dentist</p>
                            </div>
                        </div>  
                        {/* Hero Image Tag End */}

                        {/* Hero Icon List Start */}
                        <div className="hero-icon-list">
                            <div className="hero-icon-box-1">
                                <img src="images/icon-hero-theeth-1.svg" alt="" />
                            </div>

                            <div className="hero-icon-box-2">
                                <img src="images/icon-hero-theeth-2.svg" alt="" />
                            </div>

                            <div className="hero-icon-box-3">
                                <img src="images/icon-hero-theeth-3.svg" alt="" />
                            </div>
                        </div>
                        {/* Hero Icon List End */}

                        {/* Icon Start Image Start */}
                        <div className="icon-star-image">
                            <img src="images/icon-star.svg" alt="" />
                        </div>
                        {/* Icon Start Image End */}
                    </div>
                    {/* Hero Image End */}
                </div>
            </div>
        </div>
	</div>
	{/* Hero Section End */}

    {/* Call To Action Start */}
    <div className="cta-box">
        <div className="container">
            <div className="row align-items-center">
                <div className="col-lg-4 col-md-6 col-12">
                    {/* Cta Box Item Start */}
                    <div className="cta-box-item wow fadeInUp">
                        <div className="icon-box">
                            <img src="images/icon-cta-phone.svg" alt="" />
                        </div>
                        <div className="cta-box-content">
                            <h3>need dental services ?</h3>
                            <p>Call on : 7887919983</p>
                        </div>
                    </div>
                </div>
                {/* Cta Box Item End */}

                {/* Cta Box Item Start */}
                <div className="col-lg-5 col-md-6 col-12">
                    <div className="cta-box-item wow fadeInUp" data-wow-delay="0.25s">
                        <div className="icon-box">
                            <img src="images/icon-cta-time.svg" alt="" />
                        </div>
                        <div className="cta-box-content">
                            <h3>opening hours</h3>
                            <p>Mon to Sat 11:00AM to 2:00PM & 5:00PM to 7:00PM</p>
                        </div>
                    </div>
                </div>
                {/* Cta Box Item End */}

                <div className="col-lg-3 col-md-12 col-12">
                    {/* Cta Box Btn Start */}
                    <div className="cta-box-btn wow fadeInUp" data-wow-delay="0.5s">
                            <Link className="btn-default btn-highlighted" to={"/appointment"}>make an appointment</Link>
                    </div>
                    {/* Cta Box Btn End */}
                </div>
            </div>
        </div>
    </div>
    {/* Call To Action End */}

    {/* About Us Section Start */}
	<div className="about-us">
        <div className="container">
            <div className="row align-items-center">
                <div className="col-lg-6">
                    {/* About Image Start */}
                    <div className="about-image">
                        <div className="about-img-1">
                            <figure className="image-anime reveal">
                                <img src="images/about-us-img-1.jpg" alt=""/>
                            </figure>
                        </div>

                        <div className="about-img-2">
                            <figure className="image-anime reveal">
                                <img src="images/about-us-img-2.jpg" alt="" />
                            </figure>
                        </div>

                        {/* About Experience Circle Start */}
                        <div className="about-experience">
                            <figure>
                                <img src="images/about-experience-circle.png" alt="" />
                            </figure>
                        </div>
                        {/* About Experience Circle End */}
                    </div>
                    {/* About Image End */}
                </div>

                <div className="col-lg-6">
                    {/* About Content Start */}
                    <div className="about-content">
                        {/* Section Title Start */}
                        <div className="section-title">
                            <h3 className="wow fadeInUp">about us</h3>
                            <h1 className="text-anime-style-2" data-cursor="-opaque"><span>City Dental Clinic</span>  with Best Dentist in Palus</h1>
                            <p className="wow fadeInUp" data-wow-delay="0.25s">City Dental Clinic, established in 2015, is dedicated to providing exceptional dental care with a patient-first approach. We offer comprehensive dental treatments, combining expertise, modern technology, and compassionate service to ensure the best oral health for every patient.</p>
                        </div>
                        {/* Section Title End */}

                        {/* About Us Body Start */}
                        <div className="about-us-body wow fadeInUp" data-wow-delay="0.5s">
                            <ul>
                                <li>experienced team</li>
                                <li>comprehensive services</li>
                                <li>state-of-the-art technology</li>
                                <li>emergency dental services</li>
                            </ul>
                        </div>
                        {/* About Us Body End */}

                        {/* About Us Footer Start */}
                        <div className="about-us-footer wow fadeInUp" data-wow-delay="0.75s">
                            <Link className="btn-default" to={"/about"}>read more about us</Link>
                        </div>
                        {/* About Us Footer End */}
                    </div>
                    {/* About Content End */}
                </div>
            </div>
        </div>
    </div>
    {/* About Us Section End */}

    {/* Our Serviceds Section Start */}
    <div className="our-services">
        <div className="container">
            <div className="row section-row">
                <div className="col-lg-12">
                    {/* Section Title Start */}
                    <div className="section-title">
                        <h3 className="wow fadeInUp">our services</h3>
                        <h1 className="text-anime-style-2" data-cursor="-opaque"><span>Best Dental Clinic in Palus</span> for you.</h1>
                        <p className="wow fadeInUp" data-wow-delay="0.25s">We are committed to sustainability. eco-friendly initiatives.</p>
                    </div>
                    {/* Section Title End */}
                </div>
            </div>

            <div className="row">
                <div className="col-lg-3 col-md-6">
                    {/* Service Item Start */}
                    <div className="service-item wow fadeInUp">
                        <div className="icon-box">
                            <div className="img">
                                <img src="images/icon-services-1.svg" alt="" />
                            </div>
                        </div>
                        <div className="service-body">
                            <h3>general dental care</h3>
                            <p>Comprehensive dental services focused on maintaining healthy teeth and gums through routine check-ups, preventive care, and personalized treatment plans.</p>
                        </div>
                        <div className="read-more-btn">
                            <Link to={"/service"}>read more</Link>
                        </div>
                    </div>
                    {/* Service Item End */}
                </div>

                <div className="col-lg-3 col-md-6">
                    {/* Service Item Start */}
                    <div className="service-item wow fadeInUp" data-wow-delay="0.25s">
                        <div className="icon-box">
                            <div className="img">
                                <img src="images/icon-services-2.svg" alt="" />
                            </div>
                        </div>
                        <div className="service-body">
                            <h3>dental implants</h3>
                            <p>A permanent solution for missing teeth, providing natural-looking replacements that restore your smile, improve chewing ability, and support long-term oral health.</p>
                        </div>
                        <div className="read-more-btn">
                            <Link to={"/service"}>read more</Link>
                        </div>
                    </div>
                    {/* Service Item End */}
                </div>

                <div className="col-lg-3 col-md-6">
                    {/* Service Item Start */}
                    <div className="service-item wow fadeInUp" data-wow-delay="0.5s">
                        <div className="icon-box">
                            <div className="img">
                                <img src="images/icon-services-3.svg" alt="" />
                            </div>
                        </div>
                        <div className="service-body">
                            <h3>cosmetic dentistry</h3>
                            <p>Enhance the appearance of your smile with advanced cosmetic treatments designed to improve the color, shape, alignment, and overall aesthetics of your teeth.</p>
                        </div>
                        <div className="read-more-btn">
                            <Link to={"/service"}>read more</Link>
                        </div>
                    </div>
                    {/* Service Item End */}
                </div>

                <div className="col-lg-3 col-md-6">
                    {/* Service Item Start */}
                    <div className="service-item wow fadeInUp" data-wow-delay="0.75s">
                        <div className="icon-box">
                            <div className="img">
                                <img src="images/icon-services-4.svg" alt="" />
                            </div>
                        </div>
                        <div className="service-body">
                            <h3>Orthodontic Treatment</h3>
                            <p>Orthodontic treatment helps correct misaligned teeth and jaw irregularities using braces or clear aligners. It improves your smile, bite function, and overall oral health.</p>
                        </div>
                        <div className="read-more-btn">
                            <Link to={"/service"}>read more</Link>
                        </div>
                    </div>
                    {/* Service Item End */}
                </div>

                <div className="col-lg-12">
                    {/* Service Box Footer Start */}
                    <div className="services-box-footer wow fadeInUp" data-wow-delay="1s">
                        <p>We believe in using the latest technology and techniques to ensure the best outcomes for our patients.</p>
                            <Link className="btn-default" to={"/service"}>view all services</Link>
                    </div>
                    {/* Service Box Footer End */}
                </div>
            </div>
        </div>

        {/* Intro Clinic Video Section Start */}
        <div className="intro-clinic-video">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-lg-12">
                        {/* Visit Clinic Start */}
                        <div className="visit-clinic parallaxie">
                            {/* Visit Clinic Content Start */}
                            <div className="visit-clinic-content">
                                {/* Section Title Start */}
                                <div className="section-title">
                                    <h3 className="wow fadeInUp">visit clinic</h3>
                                    <h2 className="text-anime-style-2" data-cursor="-opaque">Comprehensive Dental Care For All Ages</h2>
                                </div>
                                {/* Section Title End */}
    
                                {/* Visit Clinic Btn Start */}
                                <div className="visit-clinic-btn wow fadeInUp" data-wow-delay="0.25s" data-cursor-text="Play">
                                    <a href="https://youtube.com/shorts/x7ne4IdvAj8?si=NtF6t1uukNATDe6_" className="popup-video play-btn">play video</a>
                                </div>
                                {/* Visit Clinic Btn End */}
                            </div>
                            {/* Visit Clinic Content End */}                      
                        </div>
                        {/* Visit Clinic End */}
                    </div>
                </div>
            </div>
        </div>
        {/* Intro Clinic Video Section End */}

        {/* Our Counter Section Start */}
        <div className="our-counter">
            <div className="container">
                <div className="row">
                    <div className="col-lg-3 col-md-6">
                        {/* Counter Item Start */}
                        <div className="counter-item">
                            {/* Counter Title Start */}
                            <div className="counter-title">
                                <h2><span className="counter">25000</span>+</h2>
                                <h3>Successful Treatments</h3>
                            </div>
                            {/* Counter Title End */}                     

                            {/* Counter Content Start */}
                            <div className="counter-content">
                                <p>We have successfully completed thousands of dental procedures with excellent patient outcomes.</p>
                            </div>
                            {/* Counter Content End */}
                        </div>
                        {/* Counter Item End */}
                    </div>

                    <div className="col-lg-3 col-md-6">
                        {/* Counter Item Start */}
                        <div className="counter-item">
                            {/* Counter Title Start */}
                            <div className="counter-title">
                                <h2><span className="counter">100</span>%</h2>
                                <h3>Patient-Focused Care</h3>
                            </div>
                            {/* Counter Title End */}                     

                            {/* Counter Content Start */}
                            <div className="counter-content">
                                <p>Every treatment plan is personalized to meet your unique dental needs and goals.</p>
                            </div>
                            {/* Counter Content End */}
                        </div>
                        {/* Counter Item End */}
                    </div>

                    <div className="col-lg-3 col-md-6">
                        {/* Counter Item Start */}
                        <div className="counter-item">
                            {/* Counter Title Start */}
                            <div className="counter-title">
                                <h2><span className="counter">25</span>K</h2>
                                <h3>happy customers</h3>
                            </div>
                            {/* Counter Title End */}                     

                            {/* Counter Content Start */}
                            <div className="counter-content">
                                <p>Our team loves dental trivia. Did you know that tooth enamel.</p>
                            </div>
                            {/* Counter Content End */}
                        </div>
                        {/* Counter Item End */}
                    </div>

                    <div className="col-lg-3 col-md-6">
                        {/* Counter Item Start */}
                        <div className="counter-item">
                            {/* Counter Title Start */}
                            <div className="counter-title">
                                <h2><span className="counter">15</span>+</h2>
                                <h3>Years of Clinical Experience</h3>
                            </div>
                            {/* Counter Title End */}                     

                            {/* Counter Content Start */}
                            <div className="counter-content">
                                <p>Our experienced dental team provides trusted, high-quality care using modern treatment techniques.</p>
                            </div>
                            {/* Counter Content End */}
                        </div>
                        {/* Counter Item End */}
                    </div>
                </div>
            </div>
        </div>
        {/* Our Counter Section End */}

        {/* Icon Start Image Start */}
        <div className="icon-star-image">
            <img src="images/icon-star.svg" alt="" />
        </div>
        {/* Icon Start Image End */}
    </div>
    {/* Our Serviceds Section End */}

    {/* Why Choose Us Section Start */}
    <div className="why-choose-us">
        <div className="container">
            <div className="row section-row">
                <div className="col-lg-12">
                    {/* Section Title Start */}
                    <div className="section-title">
                        <h3 className="wow fadeInUp">why choose us</h3>
                        <h1 className="text-anime-style-2" data-cursor="-opaque"><span>City Dental </span> Clinic</h1>
                        <p className="wow fadeInUp" data-wow-delay="0.25s">We are committed to sustainability. eco-friendly initiatives.</p>
                    </div>
                    {/* Section Title End */}
                </div>
            </div>

            <div className="row">
                <div className="col-lg-4 col-md-6 order-1">
                    {/* Why Choose Box Start */}
                    <div className="why-choose-box-1">
                        {/* Why Choose Item Start */}
                        <div className="why-choose-item wow fadeInUp">
                            {/* Icon Box Start */}
                            <div className="icon-box">
                                <img src="images/icon-why-us-1.svg" alt="" />
                            </div>  
                            {/* Icon Box End */}

                            {/* Why Choose Content Start */}
                            <div className="why-choose-content">
                                <h3>experienced doctor</h3>
                                <p>Highly skilled professionals delivering quality and trusted dental care.</p>
                            </div>
                            {/* Why Choose Content End */}
                        </div>
                        {/* Why Choose Item End */}

                        {/* Why Choose Item Start */}
                        <div className="why-choose-item wow fadeInUp" data-wow-delay="0.25s">
                            {/* Icon Box Start */}
                            <div className="icon-box">
                                <img src="images/icon-why-us-2.svg" alt="" />
                            </div>  
                            {/* Icon Box End */}

                            {/* Why Choose Content Start */}
                            <div className="why-choose-content">
                                <h3>personalized care</h3>
                                <p>Tailored dental treatments designed to meet each patient’s unique needs.</p>
                            </div>
                            {/* Why Choose Content End */}
                        </div>
                        {/* Why Choose Item End */}

                        {/* Why Choose Item Start */}
                        <div className="why-choose-item wow fadeInUp" data-wow-delay="0.5s">
                            {/* Icon Box Start */}
                            <div className="icon-box">
                                <img src="images/icon-why-us-3.svg" alt="" />
                            </div>  
                            {/* Icon Box End */}

                            {/* Why Choose Content Start */}
                            <div className="why-choose-content">
                                <h3>flexible payment options</h3>
                                <p>Convenient plans designed to make dental care affordable for everyone.</p>
                            </div>
                            {/* Why Choose Content End */}
                        </div>
                        {/* Why Choose Item End */}
                    </div>
                    {/* Why Choose Box Start */}
                </div>

                <div className="col-lg-4 order-lg-1 order-md-2 order-1">
                    {/* Why Choose Image Start */}
                    <div className="why-choose-image wow fadeInUp">
                        <figure>
                            <img src="images/why-choose-us-img.png" alt="" />
                        </figure>
                    </div>
                    {/* Why Choose Image End */}
                </div>

                <div className="col-lg-4 col-md-6 order-lg-2 order-md-1 order-2">
                    {/* Why Choose Box Start */}
                    <div className="why-choose-box-2">
                        {/* Why Choose Item Start */}
                        <div className="why-choose-item wow fadeInUp">
                            {/* Icon Box Start */}
                            <div className="icon-box">
                                <img src="images/icon-why-us-4.svg" alt="" />
                            </div>  
                            {/* Icon Box End */}

                            {/* Why Choose Content Start */}
                            <div className="why-choose-content">
                                <h3>emergency services</h3>
                                <p>Quick and reliable dental care for urgent pain and accidents.</p>
                            </div>
                            {/* Why Choose Content End */}
                        </div>
                        {/* Why Choose Item End */}

                        {/* Why Choose Item Start */}
                        <div className="why-choose-item wow fadeInUp" data-wow-delay="0.25s">
                            {/* Icon Box Start */}
                            <div className="icon-box">
                                <img src="images/icon-why-us-5.svg" alt="" />
                            </div>  
                            {/* Icon Box End */}

                            {/* Why Choose Content Start */}
                            <div className="why-choose-content">
                                <h3>positive patient reviews</h3>
                                <p>Trusted by patients for excellent care and satisfying treatment experiences.</p>
                            </div>
                            {/* Why Choose Content End */}
                        </div>
                        {/* Why Choose Item End */}

                        {/* Why Choose Item Start */}
                        <div className="why-choose-item wow fadeInUp" data-wow-delay="0.5s">
                            {/* Icon Box Start */}
                            <div className="icon-box">
                                <img src="images/icon-why-us-6.svg" alt="" />
                            </div>  
                            {/* Icon Box End */}

                            {/* Why Choose Content Start */}
                            <div className="why-choose-content">
                                <h3>latest technology</h3>
                                <p>Advanced dental equipment ensuring accurate, safe, and efficient treatments.</p>
                            </div>
                            {/* Why Choose Content End */}
                        </div>
                        {/* Why Choose Item End */}
                    </div>
                    {/* Why Choose Box Start */}
                </div>
            </div>
        </div>
        {/* Icon Start Image Start */}
        <div className="icon-star-image">
            <img src="images/icon-star.svg" alt="" />
        </div>
        {/* Icon Start Image End */}
    </div>
    {/* Why Choose Us Section End */}

    {/* How It Work Start */}
    <div className="how-it-work">
        <div className="container">
            <div className="row align-items-center">
                <div className="col-lg-6">
                    {/* How It Work Image Start */}
                    <div className="how-it-work-img">
                        <figure className="reveal image-anime">
                            <img src="images/how-it-work-img.jpg" alt="" />
                        </figure>
                    </div>
                    {/* How It Work Image End */}
                </div>

                <div className="col-lg-6">
                    <div className="how-it-work-content">
                        {/* Section Title Start */}
                        <div className="section-title">
                            <h3 className="wow fadeInUp">how it work</h3>
                            <h2 className="text-anime-style-2" data-cursor="-opaque"><span>What We Do</span> for Your Teeth</h2>
                            <p className="wow fadeInUp" data-wow-delay="0.25s">We provide complete dental care including preventive, restorative, and cosmetic treatments to keep your teeth healthy and strong.</p>
                        </div>
                        {/* Section Title End */}

                        {/* How Work Accordion Start */}
                        
                        {/* FAQ Accordion Start */}
                        <div className="faq-accordion how-work-accordion" id="accordion">
                            {/* FAQ Item Start */}
                            <div className="accordion-item wow fadeInUp">
                                <div className="icon-box">
                                    <img src="images/icon-how-it-work-1.svg" alt="" />
                                </div>
                                <h2 className="accordion-header" id="heading1">
                                    <button className="accordion-button" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#collapse1" aria-expanded="true" aria-controls="collapse1">
                                        book an appointment
                                    </button>
                                </h2>
                                <div id="collapse1" className="accordion-collapse collapse show" aria-labelledby="heading1"
                                    data-bs-parent="#accordion">
                                    <div className="accordion-body">
                                        <p>Schedule your visit easily and receive prompt, professional dental care at your convenience.</p>
                                    </div>
                                </div>
                            </div>
                            {/* FAQ Item End */}

                            {/* FAQ Item Start */}
                            <div className="accordion-item wow fadeInUp" data-wow-delay="0.25s">
                                <div className="icon-box">
                                    <img src="images/icon-how-it-work-2.svg" alt="" />
                                </div>
                                <h2 className="accordion-header" id="heading2">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
                                        What conditions can manual therapy treat?
                                    </button>
                                </h2>
                                <div id="collapse2" className="accordion-collapse collapse" aria-labelledby="heading2"
                                    data-bs-parent="#accordion">
                                    <div className="accordion-body">
                                        <p>Manual therapy helps treat neck and back pain, joint stiffness, muscle tightness, sports injuries, and posture-related problems.</p>
                                    </div>
                                </div>
                            </div>
                            {/* FAQ Item End */}
                            
                            {/* FAQ Item Start */}
                            <div className="accordion-item wow fadeInUp" data-wow-delay="0.5s">
                                <div className="icon-box">
                                    <img src="images/icon-how-it-work-3.svg" alt="" />
                                </div>
                                <h2 className="accordion-header" id="heading3">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#collapse3" aria-expanded="false" aria-controls="collapse3">
                                        expert care
                                    </button>
                                </h2>
                                <div id="collapse3" className="accordion-collapse collapse" aria-labelledby="heading3"
                                    data-bs-parent="#accordion">
                                    <div className="accordion-body">
                                        <p>Professional dental treatment delivered with skill, precision, and compassion.</p>
                                    </div>
                                </div>
                            </div>
                            {/* FAQ Item End */}
                        </div>
                        {/* FAQ Accordion End */}
                        {/* How Work Accordion End */}
                    </div>
                </div>
            </div>
        </div>
    </div>
    {/* How It Work End */}

    {/* Our Team Start */}
    <div className="our-team">
        <div className="container">
            <div className="row section-row">
                <div className="col-lg-12">
                    {/* Section Title Start */}
                    <div className="section-title">
                        <h3 className="wow fadeInUp">our team</h3>
                        <h1 className="text-anime-style-2" data-cursor="-opaque"><span>Best Dentists</span> in Palus</h1>
                        <p className="wow fadeInUp" data-wow-delay="0.25s">A caring group of professionals dedicated to comfortable and quality dental care.</p>
                    </div>
                    {/* Section Title End */}
                </div>
            </div>

            <div className="row justify-content-center">
                <div className="col-lg-3 col-md-6">
                    {/* Team Member Item Start */}
                    <div className="team-member-item wow fadeInUp">
                        {/* Team Image Start */}
                        <div className="team-image">
                            <figure className="image-anime">
                                <img src="images/team-1.jpeg" alt="" />
                            </figure>
                            {/* Team Social Icon End */}
                        </div>
                        {/* Team Image End */}
                
                        {/* Team Content Start */}
                        <div className="team-content">
                            <h3>dr.Vishal Patange</h3>
                            <p>MDS Orthodontist</p>
                        </div>
                        {/* Team Content End */}
                    </div>
                    {/* Team Member Item End */}
                </div>

                <div className="col-lg-3 col-md-6">
                    {/* Team Member Item Start */}
                    <div className="team-member-item wow fadeInUp" data-wow-delay="0.25s">
                        {/* Team Image Start */}
                        <div className="team-image">
                            <figure className="image-anime">
                                <img src="images/team-2.jpeg" alt="" />
                            </figure>
                            {/* Team Social Icon End */}
                        </div>
                        {/* Team Image End */}
                
                        {/* Team Content Start */}
                        <div className="team-content">
                            <h3>dr.Amruta Patange</h3>
                            <p>BDS(MUHS)</p>
                        </div>
                        {/* Team Content End */}
                    </div>
                    {/* Team Member Item End */}
                </div>
            </div>
        </div>
        </div>

    {/* Our Team End */}


    {/* Our Blog Start */}
     <div className="our-blog">
        <div className="container">
            <div className="row section-row">
                <div className="col-lg-12">
                     {/* Section Title Start */}
                     <div className="section-title">
                        <h3 className="wow fadeInUp">blogs</h3>
                        <h2 className="text-anime-style-2" data-cursor="-opaque"><span>Check Our</span> Latest Articles</h2>
                        <p className="wow fadeInUp" data-wow-delay="0.25s">We are committed to sustainability.  eco-friendly initiatives.</p>
                    </div>
                    {/* Section Title End */}
                </div>
            </div>

            <div className="row">
                      {news.map((item, index) => (

                <div className="col-lg-4 col-md-6" key={news.id}>
                    {/* Blog Item Start */}
                    <div className="blog-item wow fadeInUp">
                        {/* Post Featured Image Start*/}
                        <div className="post-featured-image" data-cursor-text="View">
                            <figure>
                                <a href="#" className="image-anime">
                                    <img  src={`https://drpatangecitydentalclinic.com/uploads/${item.image}`} alt="news" />
                                </a>
                            </figure>
                        </div>
                        {/* Post Featured Image End */}

                        {/* post Item Body Start */}
                        <div className="post-item-body">
                            <h2>{item.headline}</h2>
                            <p>{item.news_date}</p>
                        </div>
                        {/* Post Item Body End*/}

                        {/* Post Item Footer Start*/}
                        <div className="post-item-footer">
                            <Link className="read-more-btn" to={"/news"}>read more</Link>
                        </div>
                        {/* Post Item Footer End*/}
                    </div>
                    {/* Blog Item End */}
                </div>
                ))}
            </div>
        </div>
        {/* Icon Start Image Start */}
        <div className="icon-star-image">
            <img src="images/icon-star.svg" alt="" />
        </div>
        {/* Icon Start Image End */}
     </div>
    {/* Our Blog End */}

    {/* Footer Contact Us Start */}
     <div className="contact-now">
        <div className="container">
            <div className="row align-items-center">
                <div className="col-lg-6">
                    {/* Google Map Start */}
                    <div className="contact-google-map">
                        {/* Google Map Iframe Start */}
                        <div className="google-map-iframe">
<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d122034.15960517613!2d74.27667158906245!3d17.09379608409341!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc16dfdfcf5a5bb%3A0x224656ff3e8aafb7!2sCity%20Dental%20Clinic!5e0!3m2!1sen!2sin!4v1781329146839!5m2!1sen!2sin" width="600" height="450" style={{border:0}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>                        {/* Google Map Iframe End */}
                    </div>
                    </div>
                    {/* Google Map End */}
                </div>
                
                <div className="col-lg-6">

                    {/* Footer Contact Content Start */}
                    <div className="contact-now-content">
                        {/* Section Title Start */}
                        <div className="section-title">
                            <h3 className="wow fadeInUp">contact now</h3>
                            <h2 className="text-anime-style-2" data-cursor="-opaque"><span>Get Free</span> Professional Consultation</h2>
                        </div>
                        {/* Section Title End */}

                        {/* Contact Info Start */}
                        <div className="contact-now-info">
                            {/* Contact Info Item Start */}
                            <div className="contact-info-list wow fadeInUp" data-wow-delay="0.2s">
                                {/* Icon Box Start */}
                                <div className="icon-box">
                                    <img src="images/icon-location.svg" alt="" />
                                </div>
                                {/* Icon Box End */}

                                {/* Contact Info Content Start */}
                                <div className="contact-info-content">
                                    <p>Karad-Tasgaon Road, Palus</p>
                                </div>
                                {/* Contact Info Content End */}
                            </div>
                            {/* Contact Info Item End */}

                            {/* Contact Info Item Start */}
                            <div className="contact-info-list wow fadeInUp" data-wow-delay="0.4s">
                                {/* Icon Box Start */}
                                <div className="icon-box">
                                    <img src="images/icon-phone.svg" alt="" />
                                </div>
                                {/* Icon Box End */}

                                {/* Contact Info Content Start */}
                                <div className="contact-info-content">
                                    <p>7887919983</p>
                                </div>
                                {/* Contact Info Content End */}
                            </div>
                            {/* Contact Info Item End */}

                            {/* Contact Info Item Start */}
                            <div className="contact-info-list wow fadeInUp" data-wow-delay="0.6s">
                                {/* Icon Box Start */}
                                <div className="icon-box">
                                    <img src="images/icon-mail.svg" alt="" />
                                </div>
                                {/* Icon Box End */}

                                {/* Contact Info Content Start */}
                                <div className="contact-info-content">
                                    <p>citydentalclinicpalus@gmail.com</p>
                                </div>
                                {/* Contact Info Content End */}
                            </div>
                            {/* Contact Info Item End */}

                            {/* Contact Info Item Start */}
                            <div className="contact-info-list wow fadeInUp" data-wow-delay="0.8s">
                                {/* Icon Box Start */}
                                <div className="icon-box">
                                    <img src="images/icon-clock.svg" alt="" />
                                </div>
                                {/* Icon Box End */}

                                {/* Contact Info Content Start */}
                                <div className="contact-info-content">
                                    <p>Mon to Sat 11:00AM to 2:00PM & 5:00PM to 7:00PM</p>
                                </div>
                                {/* Contact Info Content End */}
                            </div>
                            {/* Contact Info Item End */}
                        </div>

                        {/* Footer Appointment Button Start  */}
                        <div className="contact-appointment-btn wow fadeInUp" data-wow-delay="1s">
                            <Link className="btn-default" to={"/appointment"}>make an appointment</Link>
                        </div>
                        {/* Footer Appointment Button End  */}
                    </div>
                    {/* Footer Contact Content End */}
                </div>
            </div>
        </div>
    </div>
    {/* Footer Contact Us End */}

 {/* Footer Start */}
    <footer className="main-footer">
        <div className="container">
            <div className="row">
                <div className="col-lg-4">
                    {/* About Footer Start */}
                    <div className="about-footer">
                        {/* Footer Logo Start */}
                        <div className="footer-logo">
                            <img src="/images/footer-logo.svg" alt="" />
                        </div>
                        {/* Footer Logo End */}

                        {/* About Footer Content Start */}
                        <div className="about-footer-content">
                            <p>Our clinic is committed to delivering compassionate care and advanced dental treatments for every patient.</p>
                         </div>
                         {/* About Footer Content End */}
                     </div>
                    {/* About Footer End */}
                </div>
                <div className="col-lg-3 col-md-4">
                    {/* Footer Quick Links Start */}
                    <div className="footer-links footer-quick-links">
                        <h3>quick links</h3>
                        <ul>                            
                            <li><Link to={`/`}>home</Link></li>
                            <li><Link to={`/about`}>about us</Link></li>
                            <li><Link to={`/service`}>services</Link></li>
                            <li><Link to={`/appointment`}>book apoointment</Link></li>
                        </ul>
                    </div>
                    {/* Footer Quick Links End */}
                </div>

                <div className="col-lg-3 col-md-4">
                    {/* Footer Social Links Start */}
                    <div className="footer-links footer-social-links">
                        <h3></h3>
                        <ul>                            
                            <li><Link to={`/photo`}>photos</Link></li>
                            <li><Link to={`/video`}>videos</Link></li>
                            <li><Link to={`/news`}>news</Link></li>
                            <li><Link to={`/contact`}>contact</Link></li>
                        </ul>
                    </div>
                    {/* Footer Social Links End */}
                </div>

                <div className="col-lg-2 col-md-4">
                    {/* Footer Contact Links Start */}
                    <div className="footer-links footer-contact-links">
                        <h3>contact us</h3>
                        <ul>                            
                            <li><a href="mailto:patangedrvishal@gmail.com?subject=Dental Appointment Inquiry">citydentalclinicpalus@gmail.com</a></li>
                            <li><a href="tel:+917887919983"> 7887919983</a></li>
                        </ul>
                    </div>
                    {/* Footer Contact Links End */}
                </div>                
            </div>

            {/* Footer Copyright Section Start */}
            <div className="footer-copyright">
                <div className="row">
                    <div className="col-lg-12">
                        {/* Footer Copyright Start */}
                        <div className="footer-copyright-text">
                            <p><Link to={"/admin/login"} className="footer-link">Copyright © 2026 All Rights Reserved.</Link></p>
                            <p><a href="tel:+918805604252" className="footer-link">Designed & Developed by Shreyas Phase(8805604252)</a></p>
                        </div>
                        {/* Footer Copyright End */}
                    </div>
                </div>
            </div>
            {/* Footer Copyright Section End */}
        </div>
    </footer>
    {/* Footer End */}
        </div>
    );
}
export default Home;